import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const resetReturn = {
  name: "resetReturn" as const,
  input: z.object({
    returnId: zExt.objectId(),
    step: z.number().optional(),
    /** The flow the step index was chosen against. */
    flowId: z.string().optional(),
    resetReason: z.string(),
    changeDefaultStep: z.boolean().optional(),
  }),
  output: z.null(),
};
